import { getItemMetaValue, getPackagingDetail } from "./productMetaFields";

/**
 * Normalize medicine/search array fields into a clean string[].
 */
export const normalizeStringList = (values) => {
	if (!Array.isArray(values)) return [];
	return values
		.map((value) => String(value ?? "").trim())
		.filter(Boolean);
};

/**
 * Read primary_use / interactions from search or saved item (snake or camel).
 * Safe when source is null/undefined (e.g. ViewMedicine before fetch).
 */
export const getPrimaryUseList = (source) => {
	const data = source ?? {};
	return normalizeStringList(data.primary_use ?? data.primaryUse);
};

export const getInteractionsList = (source) => {
	const data = source ?? {};
	return normalizeStringList(data.interactions);
};

/**
 * Attach optional list + meta fields to an add/update item payload when present.
 */
export const appendOptionalItemLists = (payload, source) => {
	const data = source ?? {};
	const primaryUse = getPrimaryUseList(data);
	const interactions = getInteractionsList(data);
	const packagingDetail = getPackagingDetail(data);
	const metaValue = getItemMetaValue(data);

	if (primaryUse.length) {
		payload.primary_use = primaryUse;
	}
	if (interactions.length) {
		payload.interactions = interactions;
	}
	if (packagingDetail) {
		payload.packaging_detail = packagingDetail;
	}
	if (metaValue) {
		payload.value = metaValue;
	}

	return payload;
};
